import React from "react";
import Swal from "sweetalert2";
import './CustomSweetAlert.scss';

const CustomSweetAlert = (options = {}, customClassProps = {}, onConfirm = () => { }, onClose = () => { }) => {
    return Swal.fire({
        customClass: {
            popup: 'custom-swal-popup',
            title: 'custom-swal-title',
            htmlContainer: 'custom-swal-text',
            confirmButton: 'custom-swal-confirm',
            actions: 'custom-swal-actions',
            ...customClassProps
        },
        buttonsStyling: false,
        showConfirmButton: true,
        icon: undefined,
        ...options,
    }).then(res => {
        if (res.isConfirmed) {
            onConfirm();
        } else if (res.isDismissed) {
            onClose();
        }
        Swal.close();
    });
};

export default CustomSweetAlert;